// Misma regla que is_driver_habilitado (0024): TECNOMECANICA se exige si existe
// AL MENOS un vehículo activo cuyo tipo no sea MOTORCYCLE.
// status: "error" (no se pudo consultar) | "none" | "moto_only" | "non_moto"
export function evaluateTecnoRequirement(vehicles, error) {
  if (error || !Array.isArray(vehicles)) {
    return { status: "error", requiresTecno: true, activeCount: 0 };
  }
  const activeCount = vehicles.length;
  if (activeCount === 0) return { status: "none", requiresTecno: false, activeCount };
  const nonMoto = vehicles.some((v) => !v || v.type !== "MOTORCYCLE");
  return { status: nonMoto ? "non_moto" : "moto_only", requiresTecno: nonMoto, activeCount };
}
